"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
function Save(_a) {
    var _b = _a.width, width = _b === void 0 ? 64 : _b, _c = _a.height, height = _c === void 0 ? 64 : _c, className = _a.className;
    return (react_1.default.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), viewBox: "0 0 22 21", width: "".concat(width) },
        react_1.default.createElement("path", { d: "M20.122 3.12l-1.555-1.555a3.364 3.364 0 00-2.381-.987H3.214A2.316 2.316 0 00.898 2.894v15.578a2.316 2.316 0 002.316 2.316h15.579a2.315 2.315 0 002.315-2.316V5.501c0-.894-.354-1.75-.986-2.382zM4.267 5.84V3.736c0-.349.283-.632.631-.632h8.842c.349 0 .632.283.632.632V5.84a.632.632 0 01-.632.632H4.898a.632.632 0 01-.631-.632zm6.736 11.579a3.79 3.79 0 11.001-7.58 3.79 3.79 0 010 7.58z", fill: "#009CFF" })));
}
Save.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
exports.default = Save;
